export default __webpack_public_path__ + "static/media/hero-liquidity-mining-home.f11c995a.svg";